(function () {
  const config = window.themeSearchHidden;

  if (!config) {
    return;
  }

  const hiddenProductIds = new Set((config.productIds || []).map(String));
  const hiddenHandles = new Set(config.handles || []);

  if (!hiddenProductIds.size && !hiddenHandles.size) {
    return;
  }

  function getHandleFromLink(link) {
    if (!link || typeof link !== 'string') {
      return '';
    }

    const match = link.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function isHiddenProduct(item) {
    if (!item) {
      return false;
    }

    const productId = String(item.product_id || item.id || '');
    const handle = item.handle || getHandleFromLink(item.link);

    return hiddenProductIds.has(productId) || (handle && hiddenHandles.has(handle));
  }

  function filterSearchData(data) {
    if (!data || !Array.isArray(data.items)) {
      return;
    }

    const visibleItems = data.items.filter((item) => !isHiddenProduct(item));
    const hiddenCount = data.items.length - visibleItems.length;

    data.items = visibleItems;

    if (hiddenCount > 0) {
      if (typeof data.currentItemCount === 'number') {
        data.currentItemCount = Math.max(0, data.currentItemCount - hiddenCount);
      }

      if (typeof data.totalItems === 'number') {
        data.totalItems = Math.max(0, data.totalItems - hiddenCount);
      }
    }
  }

  function removeHiddenProductsFromDom(root) {
    if (!root) {
      return;
    }

    root.querySelectorAll('[data-original-product-id]').forEach((element) => {
      const productId = String(element.getAttribute('data-original-product-id') || '');

      if (hiddenProductIds.has(productId)) {
        element.remove();
      }
    });

    root.querySelectorAll('.snize-product a.snize-item[href*="/products/"]').forEach((link) => {
      const handle = getHandleFromLink(link.getAttribute('href'));

      if (handle && hiddenHandles.has(handle)) {
        link.closest('.snize-product')?.remove();
      }
    });
  }

  function bindSearchanise($) {
    $(document).on('Searchanise.DataRequestEnd', function (_event, type, _params, data) {
      if (type === 'autocomplete' || type === 'results') {
        filterSearchData(data);
      }
    });

    $(document).on('Searchanise.AutocompleteUpdated', function (_event, _input, container) {
      removeHiddenProductsFromDom(container?.[0] || container);
    });

    $(document).on('Searchanise.ResultsUpdated', function (_event, container) {
      removeHiddenProductsFromDom(container?.[0] || container);
    });
  }

  function onSearchaniseReady(callback) {
    if (window.Searchanise?.$) {
      callback(window.Searchanise.$);
      return;
    }

    document.addEventListener('Searchanise.Loaded', function onLoaded() {
      document.removeEventListener('Searchanise.Loaded', onLoaded);

      if (window.Searchanise?.$) {
        callback(window.Searchanise.$);
      }
    });
  }

  onSearchaniseReady(bindSearchanise);
})();
